import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import { produtoApi } from 'app/services/api/produtoApi';
import React from 'react';

const SelectProduto = ({ id, name, label, value, touched, error, onBlur, onChange, disabled }) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.nome;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await produtoApi.pesquisar({
          size: 100,
          sort: 'nome',
          page: next,
          q: query,
        });

        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectProduto;
